import { Component } from '@angular/core';
import {ScrollProjects} from '../../components/scroll-projects/scroll-projects';
import {AppHeader} from '../../components/header/header';
import {MobileMenu} from '../../components/mobile-menu/mobile-menu';


@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    ScrollProjects,
    AppHeader,
    MobileMenu
  ],
  templateUrl: './main-page.html',
  styleUrl: './main-page.scss'
})
export class MainPage {}
